import { useState } from 'react'
import { useArrowKeyNav } from '@nv/hooks'
import clsx from 'clsx'
import { Link, useLocation } from 'react-router-dom'
import styles from './Tabs.module.scss'

export const Tabs = ({ tabs, className }: any) => {
  const location = useLocation()
  const [highlightedIndex, setHighlightedIndex] = useState(0)

  const { handleOptionsKeyDown, optionRefs } = useArrowKeyNav({ activation: 'implicit' })

  return (
    <div className={clsx(styles['container'], className)}>
      <div className={clsx(styles['wrapper'], className)} role='tablist'>
        {tabs.map((tab, index) => (
          <Link
            key={index}
            to={tab.path}
            role='tab'
            ref={(el) => (optionRefs.current[index] = el)}
            tabIndex={highlightedIndex === index ? 0 : -1}
            className={clsx(styles['tab'], {
              [styles['active']]: location.pathname === tab.path,
            })}
            onKeyDown={handleOptionsKeyDown}
            onClick={() => setHighlightedIndex(index)}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </div>
  )
}
